import React from "react";
import ScrollAnimation from "../components/ScrollAnimation";
import "./About.css";

const About = () => {
  const stats = [
    { number: "20+", label: "Yıllık Deneyim" },
    { number: "100+", label: "Mutlu Müşteri" },
    { number: "7/24", label: "Teknik Destek" },
  ];

  const values = [
    {
      icon: "🎯",
      title: "Kalite Odaklılık",
      description:
        "Her projede en yüksek kalite standartlarını uygulayarak müşteri memnuniyetini ön planda tutuyoruz.",
    },
    {
      icon: "🤝",
      title: "Güvenilirlik",
      description:
        "20 yıllık deneyimimizle sektörde güvenilir bir marka olarak tanınıyoruz.",
    },
    {
      icon: "💡",
      title: "İnovasyon",
      description:
        "Teknolojik gelişmeleri takip ederek sürekli kendimizi yeniliyoruz.",
    },
    {
      icon: "⚡",
      title: "Hızlı Çözüm",
      description: "Müşteri ihtiyaçlarına hızlı ve etkili çözümler sunuyoruz.",
    },
    {
      icon: "🕐",
      title: "7/24 Destek",
      description:
        "Müşterilerimize kesintisiz destek sağlayarak her zaman yanlarında oluyoruz.",
    },
  ];

  const brands = [
    {
      name: "Atlas Copco",
      initials: "AC",
    },
    {
      name: "Aydın Trafo",
      initials: "AT",
    },
    {
      name: "Chicago Pneumatic",
      initials: "CP",
    },
    {
      name: "CompAir",
      initials: "CA",
    },
    {
      name: "Dalgakıran Kompresör",
      initials: "DK",
    },
    {
      name: "EkoMak",
      initials: "EM",
    },
    {
      name: "Kaeser Kompresör",
      initials: "KK",
    },
    {
      name: "Komsan Kompresör",
      initials: "KK",
    },
    {
      name: "Lupamat Kompresör",
      initials: "LK",
    },
    {
      name: "Mark Kompresör",
      initials: "MK",
    },
    {
      name: "Sullair",
      initials: "SL",
    },
    {
      name: "Tecom",
      initials: "TC",
    },
    {
      name: "Vikoser",
      initials: "VS",
    },
    {
      name: "Vortex",
      initials: "VX",
    },
    {
      name: "Yiğitsan Kompresör",
      initials: "YK",
    },
  ];

  const team = [
    {
      name: "Mehmet Yılmaz",
      position: "Genel Müdür",
      experience: "15 yıl deneyim",
      image: "👨‍💼",
    },
    {
      name: "Ayşe Demir",
      position: "Teknik Müdür",
      experience: "12 yıl deneyim",
      image: "👩‍🔧",
    },
    {
      name: "Ali Kaya",
      position: "Satış Müdürü",
      experience: "10 yıl deneyim",
      image: "👨‍💻",
    },
    {
      name: "Fatma Özkan",
      position: "Müşteri Hizmetleri",
      experience: "8 yıl deneyim",
      image: "👩‍💼",
    },
  ];

  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="container">
          <h1 className="page-title">Hakkımızda</h1>
          <p className="page-subtitle">
            RPM Kompresör olarak endüstriyel kompresör çözümlerinde 20 yıllık
            deneyimimizle sektörde öncü konumdayız.
          </p>
        </div>
      </div>

      <div className="about-content">
        <div className="container">
          <section className="mission-card">
            <ScrollAnimation direction="left" delay={0}>
              <div className="mission-content">
                <h2>Misyonumuz</h2>
                <p>
                  Kompresör tamir, bakım, servis ve yedek parça temini konusunda
                  müşteri memnuniyetini ön planda tutarak kesintisiz, en
                  ulaşılabilir ve sonuç odaklı hizmeti verebilmek.
                </p>
              </div>
              <div className="card-decoration">🎯</div>
            </ScrollAnimation>
          </section>

          <section className="vision-card">
            <ScrollAnimation direction="left" delay={200}>
              <div className="vision-content">
                <h2>Vizyonumuz</h2>
                <p>
                  Hizmet ağırlıklı bu sektörün en güvenilir firması olarak tüm
                  Türkiye'de aranan ve tercih edilen markası haline gelebilmek.
                </p>
              </div>
              <div className="card-decoration">🚀</div>
            </ScrollAnimation>
          </section>
          <section className="about-story">
            <ScrollAnimation direction="left" delay={0}>
              <div className="story-content">
                <h2>Hikayemiz</h2>
                <p>
                  RPM GRUP ENDÜSTRİ KOMPRESÖR olarak 20 yılı aşkın personel
                  deneyimleriyle, Distribütörü olduğumuz Aydın trafo ile
                  birlikte sizlere en iyi hizmeti vermeye çalışıyoruz.
                </p>
                <p>
                  Müşteri memnuniyetini her şeyin üstünde tutan anlayışımızla,
                  kaliteli ürünler ve profesyonel hizmet sunmaya devam ediyoruz.
                  Teknolojik gelişmeleri yakından takip ederek, sürekli
                  kendimizi yeniliyor ve müşterilerimize en iyi hizmeti
                  sunuyoruz.
                </p>
              </div>
            </ScrollAnimation>
          </section>

          <section className="stats-section">
            <div className="stats-grid">
              {stats.map((stat, index) => (
                <ScrollAnimation key={index} direction="up" delay={index * 100}>
                  <div className="stat-item">
                    <div className="stat-number">{stat.number}</div>
                    <div className="stat-label">{stat.label}</div>
                  </div>
                </ScrollAnimation>
              ))}
            </div>
          </section>

          <section className="values-section">
            <h2 className="section-title">Değerlerimiz</h2>
            <div className="values-grid">
              {values.map((value, index) => (
                <ScrollAnimation
                  key={index}
                  direction="left"
                  delay={index * 150}
                >
                  <div className="value-card">
                    <div className="value-icon">{value.icon}</div>
                    <h3 className="value-title">{value.title}</h3>
                    <p className="value-description">{value.description}</p>
                  </div>
                </ScrollAnimation>
              ))}
            </div>
          </section>

          <section className="brands-section">
            <h2 className="section-title">Çalıştığımız Markalar</h2>
            <p className="section-subtitle">
              20+ yıllık deneyimimizle çok sayıda uluslararası markanın
              kompresörlerinin bakım ve onarım hizmetlerini profesyonelce
              gerçekleştiriyoruz.
            </p>
            <div className="brands-grid">
              {brands.map((brand, index) => (
                <ScrollAnimation key={index} direction="up" delay={index * 50}>
                  <div className="brand-card">
                    <div className="brand-logo">
                      <span className="brand-initials">{brand.initials}</span>
                    </div>
                    <h3 className="brand-name">{brand.name}</h3>
                  </div>
                </ScrollAnimation>
              ))}
            </div>
          </section>

          {/*
          <section className="team-section">
            <h2 className="section-title">Ekibimiz</h2>
            <div className="team-grid">
              {team.map((member, index) => (
                <ScrollAnimation
                  key={index}
                  direction="right"
                  delay={index * 100}
                >
                  <div className="team-card">
                    <div className="member-image">{member.image}</div>
                    <h3 className="member-name">{member.name}</h3>
                    <p className="member-position">{member.position}</p>
                    <p className="member-experience">{member.experience}</p>
                  </div>
                </ScrollAnimation>
              ))}
            </div>
          </section>
          */}
        </div>
      </div>
    </div>
  );
};

export default About;
